import React, { Component } from 'react';
import { Form, Text, TextArea, Select } from 'informed';

import ContactFormItem from '../ContactFormItem/ContactFormItem';

import './ContactForm.css';

const Error = ({ text }) => {
  return <p className="error" dangerouslySetInnerHTML={{ __html: text }} />;
};

const Success = ({ text }) => {
  return <p className="success" dangerouslySetInnerHTML={{ __html: text }} />;
};

class ContactForm extends Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  state = {
    error: '',
    success: '',
  };

  handleSubmit(data) {
    this.setState({
      error: '',
    });
    const { email } = data;
    if (!email || email.indexOf('@') === -1) {
      this.setState({
        error: `${this.state.error}<br/>Veuillez vérifier votre adresse email.`,
      });
      return;
    }

    fetch('/sendmail.php', {
      method: 'POST',
      body: JSON.stringify(data),
    }).then(() => {
      this.setState({
        success: 'Votre demande de contact a bien été envoyée.',
        error: '',
      });
    });
  }
  render() {
    return (
      <Form
        id="contact-form"
        action=""
        method="post"
        onSubmit={this.handleSubmit}
      >
        <ContactFormItem
          label="Nom"
          name="nom"
          Type={Text}
          placeholder="Votre nom"
          cols="2-cols"
        />
        <ContactFormItem
          label="Prénom"
          name="prenom"
          Type={Text}
          placeholder="Votre prénom"
          cols="2-cols"
        />
        <ContactFormItem
          label="Adresse email"
          name="email"
          Type={Text}
          placeholder="Votre adresse email"
        />
        <ContactFormItem
          label="Téléphone"
          name="telephone"
          Type={Text}
          placeholder="Votre numéro de téléphone"
        />
        <ContactFormItem
          label="Objet"
          name="objet"
          Type={Select}
          placeholder="Objet de votre message"
        />
        <ContactFormItem
          label="Message"
          name="message"
          Type={TextArea}
          placeholder="Saisissez votre message"
        />
        <button type="submit">Envoyer</button>
        <Error text={this.state.error} />
        <Success text={this.state.success} />
      </Form>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/Components/Contact/ContactForm/ContactForm.js